module.exports = __webpack_public_path__ + "assets/img/KeyReport_Focus_en.7106dc8e.svg";